import qs from 'qs'
import {
  isInPZAPP,
  pzOpenWebPage
} from '@/utils/bridge'

/**
 * 防抖
 * @param {*} fn
 * @param {*} delay
 * @returns null
 */
export function debonce (fn, delay) {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}

/**
 * 节流
 * @param {*} fn
 * @param {*} delay
 * @returns null
 */
export function throttle (fn, delay) {
  let valid = true
  return function () {
    if (!valid) {
      // 休息时间 暂不接客
      return false
    }
    // 工作时间，执行函数并且在间隔期内把状态位设为无效
    valid = false
    setTimeout(() => {
      fn.apply(this, arguments)
      valid = true
    }, delay)
  }
}

/**
 * 获取渠道码
 * @returns channelCode
 */
export function getChannelCode () {
  let channelCode = ''
  const _url = window.location.href
  const _data = qs.parse(_url.split('?')[1]) || {}
  if (_data.channelCode) {
    channelCode = _data.channelCode
  } else {
    if (_data.targetUrl) {
      const _targetUrl = decodeURIComponent(_data.targetUrl)
      const urlQuery = qs.parse(decodeURIComponent(_targetUrl).split('?')[1]) || {}
      if (urlQuery.channelCode) {
        channelCode = urlQuery.channelCode
      }
    }
  }
  if (!channelCode) {
    try {
      channelCode = window.sessionStorage.getItem('channelCode')
    } catch (e) {
      channelCode = '001'
    }
  }
  if (!channelCode) {
    channelCode = '001'
  }
  return channelCode
}

/**
 * 设置全局样式（根据接口数据换主题色）
 * @param {*} colors
 * @returns null
 */
export function setTemplateColors (colors) {
  const oStyle = document.createElement('style')
  oStyle.setAttribute('markName', 'color-resize')
  let backgroundStyle = ''
  if (colors.background) {
    if (/^https?:\/\//.test(colors.background) || colors.background.startsWith('data:image')) {
      // 图片
      backgroundStyle = `#app { background-image: url('${colors.background}'); background-size: cover; background-repeat: no-repeat; }`
    } else {
      // 颜色
      backgroundStyle = `#app { background: ${colors.background}; }`
    }
    // 控制台输出
    try {
      console.log('"backgroundStyle":', JSON.stringify(backgroundStyle))
    } catch (e) {}
  }
  const colorStyleStr = `
    ${backgroundStyle}
    .van-notice-bar {
      color: ${colors.theme};
    }
    .van-button--primary {
      background-color: ${colors.theme};
      border-color: ${colors.theme};
    }
    .van-button--primary.van-button--plain {
      background-color: #ffffff;
      color: ${colors.theme};
    }
    .van-checkbox__icon--checked .van-icon, .van-radio__icon--checked .van-icon {
      background-color:  ${colors.theme};
      border-color:  ${colors.theme};
    }
    .van-step__circle {
      border-color:  ${colors.theme};
    }
    .rule-step-box .van-step__circle {
      width: 12px;
      height: 12px;
      background: #ffffff;
      border: 1px solid ${colors.theme};
      position: relative;
    }
    .rule-step-box .van-step__circle:after {
      content: ' ';
      display: block;
      width: 7px;
      height: 7px;
      border-radius: 7px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: ${colors.theme};
    }
    .rule-step-box .van-step__line {
      background: ${colors.theme};
    }
    .van-step__icon--active, .van-step__title--active, .van-step__icon--finish, .van-step__title--finish{
      color: ${colors.theme};
    }
    .van-tabs__line {
      background-color: ${colors.theme};
    }
    .van-tab.van-tab--active .van-tab__text {
      color: ${colors.theme};
    }
    .van-icon-checked {
      color: ${colors.theme};
    }
    .van-dropdown-menu__title--active {
      color: ${colors.theme};
    }
    .van-dropdown-item__option--active {
      color: ${colors.theme};
    }
    .van-tag--primary.van-tag--plain {
      color: ${colors.theme};
    }
    .van-tag--primary {
      background-color: ${colors.theme}
    }
    .van-tag--plain {
      background-color: #ffffff;
    }
    .van-dialog__confirm, .van-dialog__confirm:active {
      color: ${colors.theme};
    }
    .common-footer-item.active {
      color: ${colors.theme};
    }
    .common-footer-item.active .van-grid-item__text {
      color: ${colors.theme};
    }
    .detail-bg-color:before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 6.56rem;
      background: linear-gradient( 180deg , ${colors.theme}, ${colors.bg});
    }
    .detail-bg-color-theme-white:before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 6.56rem;
      background-image: linear-gradient(180deg, ${colors.theme} 20%, rgba(222,198,172,0.00) 76%);
    }
    .text-theme-color {
      color: ${colors.theme}!important;
    }
    .bg-theme-color {
      background: ${colors.theme}!important;
    }
    .border-theme-color {
      border: 1px solid ${colors.theme}!important;
    }
    .border-theme-color-self, .border-color-theme {
      border-color: ${colors.theme}!important;
    }
    .van-popup--bottom.van-popup--round {
      border-radius: 20px 20px 0 0;
    }
    .van-dialog__cancel .van-button__text {
      color: var(--tips-text-color);
    }
    .menu-popup .title .cancel {
      right: 16px !important;
      left: auto !important;
    }
  `
  oStyle.innerHTML = colorStyleStr
  document.head.appendChild(oStyle)
}

export function setTitle (title) {
  document.title = title
  const oFrame = document.createElement('iframe')
  oFrame.style.display = 'none'
  oFrame.onload = function () {
    setTimeout(() => {
      if (oFrame) {
        try {
          oFrame.parentNode.removeChild(oFrame)
        } catch (e) {}
      }
    }, 0)
  }
  document.body.appendChild(oFrame)
  oFrame.src = '/logo.png'
}

export function openRule (url) {
  url = url.substring(0, 4) === 'http' ? url : window.location.origin + url
  if (isInPZAPP) {
    pzOpenWebPage(
      {
        url: url,
        hasAppBar: '1'
      }
    )
  } else {
    window.open(url, '_blank')
  }
}

export function getShareUrl (url, customerNo = '') {
  let str = ''
  const custNo = customerNo ? 'C' + btoa(customerNo) : ''
  if (url.includes('channelCode')) {
    str = url.replace(/(channelCode=)[^&]*/, `$1${custNo}`)
  } else {
    str = url.includes('?') ? url + '&channelCode=' + custNo : url + '?channelCode=' + custNo
  }
  return str
}

/**
 * 将传入的数字转换为以"万"为单位的字符串表示形式
 * @param {number} num - 要转换的数字
 * @returns {string} - 转换后的字符串
 */
export function convertToWan (num) {
  if (!num) return null
  // 如果数字的绝对值小于 10000，直接返回原始数字
  if (Math.abs(num) < 10000) {
    return num.toString()
  }

  // 将大于等于 10000 的数字（包括负数）转换为以"万"为单位的字符串
  const wan = (num / 10000).toFixed(2) // 保留两位小数
  return `${wan}万`
}

/**
 * 判断是否为移动端
 * @returns {boolean} - 是还是不是
 */
export function isMobile () {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
